{
    "NAME": "Tipos de dispositivo Idioma",
    "DeviceTypesLanguage_Unknown": "Desconhecido",
    "DeviceTypesLanguage_Trunk": "Porta-malas",
    "DeviceTypesLanguage_TrunkGateway": "Portal do tronco",
    "DeviceTypesLanguage_ChatService": "Serviço de bate-papo",
    "DeviceTypesLanguage_EmailServer": "Servidor de e-mail",
    "DeviceTypesLanguage_ExtensionOrEndpoint": "Extensão\/Ponto de extremidade",
    "DeviceTypesLanguage_ExtensionOrEndpointTrunking": "Extensão (Tronco)",
    "DeviceTypesLanguage_ExtensionOrEndpointHospitality": "Extensão (Hospitalidade)",
    "DeviceTypesLanguage_GroupSuper": "Supergrupo",
    "DeviceTypesLanguage_GroupCollective": "Grupo (Coletivo)",
    "DeviceTypesLanguage_GroupLinear": "Grupo (Linear)",
    "DeviceTypesLanguage_GroupCyclic": "Grupo (Cíclico)",
    "DeviceTypesLanguage_GroupAcd": "Grupo (ACD)",
    "DeviceTypesLanguage_GroupTrunk": "Grupo (Tronco)",
    "DeviceTypesLanguage_GroupVoicemail": "Grupo (Correio de Voz)",
    "DeviceTypesLanguage_GroupPage": "Grupo (Página)",
    "DeviceTypesLanguage_GroupDepartment": "Departamento",
    "DeviceTypesLanguage_GroupSecurityGroup": "Grupo de Segurança",
    "DeviceTypesLanguage_GroupSecurityGroupBroadworks": "Grupos de Prestadores de Serviços",
    "DeviceTypesLanguage_GroupAcdMsTeams": "Filas de chamadas",
    "DeviceTypesLanguage_Park": "Parque",
    "DeviceTypesLanguage_VoicemailApplication": "Aplicativo de correio de voz",
    "DeviceTypesLanguage_VoicemailAnnouncementHuntGroup": "Anúncio de fila (grupo de busca)",
    "DeviceTypesLanguage_VoicemailAnnouncementGeneral": "Anúncio de fila (Geral)",
    "DeviceTypesLanguage_AutoAttendant": "Atendente automático",
    "DeviceTypesLanguage_MusicOnHold": "Música em espera",
    "DeviceTypesLanguage_Conference": "Conferência",
    "DeviceTypesLanguage_PilotNumber": "Piloto\/Alternativo",
    "DeviceTypesLanguage_DnisEntry": "Entrada DNIS"
}